import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header__title" }
const _hoisted_4 = { class: "header__buttons" }
const _hoisted_5 = {
  key: 1,
  class: "content__navigation"
}
const _hoisted_6 = { class: "content__navigation__text" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 3,
  class: "content__text"
}
const _hoisted_9 = {
  key: 4,
  class: "content__loading-spinner"
}

import { onMounted, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import { useGeneralStore } from '@/pinia'
import pdfvuer from 'pdfvuer/src/Pdfvuer.vue'
import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
import IconChevronRight from '@/design-system/assets/icons/IconChevronRight.vue'
import IconChevronLeft from '@/design-system/assets/icons/IconChevronLeft.vue'
import LayoutOverlay from '@/design-system/templates/LayoutOverlay.vue'
import OverlayCard from '@/design-system/molecules/OverlayCard.vue'
import ConfirmDeleteAttachmentCard from '@/components/features/attachments/ConfirmDeleteAttachmentCard.vue'
import TooltipStandardV2 from '@/design-system/atoms/TooltipStandardV2.vue'
import { archiveAttachments, deleteAttachments } from '@/services/attachments.service'
import { getAttachmentFileBlob } from '@/services/files.service'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
// import useFileList from '@/hooks/files/useFileList'
// emits
interface EMITS {
  (e: 'closePreviewFileModal', val: boolean)
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ModalPreviewFile',
  emits: ["closePreviewFileModal"],
  setup(__props, { emit: __emit }) {

const emits = __emit

// variables
const { t } = useI18n()
const store = useStore()
const piniaStore = useGeneralStore()
// const { removeFile } = useFileList()

const fileBlobSource = ref('')
const fileType = ref<string | undefined>('')
const loadingFile = ref(false)
const pdfCurrentPage = ref(1)
const pdfNumPages = ref(1)
const showConfirmDelete = ref(false)
const showPreviewFailedText = ref(false)

// computed

// methods
async function archiveFile() {
  if (!piniaStore.selectedFile) return
  try {
    const id = piniaStore.selectedFile.attachmentId
    if (!id) return
    const response = await archiveAttachments([id])
    // For future bulk operations, check "succeeded" array for each file insead of current "success" boolean
    if (response?.data.success) {
      // remove file from filesList in store
      const filesArray = piniaStore.filesList.filter((file) => file.attachmentId !== id)
      piniaStore.setFilesList(filesArray)
      piniaStore.setSelectedFile(null)
      closeModal()
    }
    if (!response?.data.success) {
      store.commit('setInfoMessage', {
        type: 'error',
        message: `${t('general__data__file-archive-failed')}, ${t(
          'general__text__retry-later-again'
        ).toLowerCase()}`
      })
    }
  } catch (e) {
    store.commit('setInfoMessage', {
      type: 'error',
      message: `${t('general__data__file-archive-failed')}, ${t(
        'general__text__retry-later-again'
      ).toLowerCase()}`
    })
    console.error(e)
  }
}
function changePage(change: string) {
  if (change === 'next') {
    if (pdfCurrentPage.value < pdfNumPages.value) pdfCurrentPage.value += 1
    return
  }
  if (pdfCurrentPage.value !== 1) pdfCurrentPage.value -= 1
}
function closeModal() {
  emits('closePreviewFileModal', false)
}
async function deleteFile() {
  if (!piniaStore.selectedFile) return
  try {
    const entityId = piniaStore.selectedFile.entityId
    const id = piniaStore.selectedFile.attachmentId
    if (!entityId || !id) return
    const response = await deleteAttachments([piniaStore.selectedFile.attachmentId])
    // For future bulk operations, check "succeeded" array for each file insead of current "success" boolean
    if (response?.data.success) {
      // remove file from filesList in store
      const filesArray = piniaStore.filesList.filter((file) => file.attachmentId !== id)
      piniaStore.setFilesList(filesArray)
      piniaStore.setSelectedFile(null)
      closeModal()
    }
    if (!response?.data.success) {
      store.commit('setInfoMessage', {
        type: 'error',
        message: `${t('general__data__file-delete-failed')}, ${t(
          'general__text__retry-later-again'
        ).toLowerCase()}`
      })
    }
  } catch (e) {
    store.commit('setInfoMessage', {
      type: 'error',
      message: `${t('general__data__file-delete-failed')}, ${t(
        'general__text__retry-later-again'
      ).toLowerCase()}`
    })
    console.error(e)
  }
}
async function downloadFile() {
  if (!piniaStore.selectedFile?.url) return
  try {
    const res = await getAttachmentFileBlob(piniaStore.selectedFile)
    if (!res) return setDownloadFailedMessage()
    // @ts-ignore
    const fileUrl = window.URL.createObjectURL(new Blob([res.data]))
    const fileLink = document.createElement('a')
    fileLink.href = fileUrl
    fileLink.setAttribute('download', piniaStore.selectedFile.name)
    document.body.appendChild(fileLink)
    fileLink.click()
  } catch (e) {
    setDownloadFailedMessage()
    console.error(e)
  }
}
async function getPreviewFile() {
  if (!piniaStore.selectedFile?.url) return
  try {
    fileType.value = piniaStore.selectedFile.fileType ?? ''
    loadingFile.value = true
    const res = await getAttachmentFileBlob(piniaStore.selectedFile)
    const blob =
      fileType?.value === 'svg'
        ? // @ts-ignore
          new Blob([res.data], { type: 'image/svg+xml' })
        : // @ts-ignore
          new Blob([res.data])
    fileBlobSource.value = window.URL.createObjectURL(blob)
    showPreviewFailedText.value = false
  } catch (e) {
    showPreviewFailedText.value = true
    console.error(e)
  } finally {
    loadingFile.value = false
  }
}
function setDownloadFailedMessage() {
  store.commit('setInfoMessage', {
    type: 'error',
    message: `${t('general__data__file-download-failed')}, ${t(
      'general__text__retry-later-again'
    ).toLowerCase()}`
  })
}

watch(fileBlobSource, () => {
  if (!fileBlobSource.value.length || fileType.value !== 'pdf') return
  const pdfdata = pdfvuer.createLoadingTask(fileBlobSource.value)
  pdfdata.then((pdf) => {
    pdfNumPages.value = pdf.numPages
  })
})

onMounted(() => {
  getPreviewFile()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LayoutOverlay, {
    class: "modal-preview-files",
    onCloseOverlay: _cache[9] || (_cache[9] = ($event: any) => (closeModal()))
  }, {
    default: _withCtx(() => [
      (showConfirmDelete.value)
        ? (_openBlock(), _createBlock(OverlayCard, {
            key: 0,
            backgroundTransparent: true,
            onCloseOverlay: _cache[2] || (_cache[2] = ($event: any) => (showConfirmDelete.value = false))
          }, {
            default: _withCtx(() => [
              _createVNode(ConfirmDeleteAttachmentCard, {
                buttonText: _unref(t)('general__text__delete') + ' ' + _unref(t)('general__data__file(s)').toLowerCase(),
                onCloseOverlay: _cache[0] || (_cache[0] = ($event: any) => (showConfirmDelete.value = false)),
                onConfirmDelete: _cache[1] || (_cache[1] = ($event: any) => (deleteFile()))
              }, null, 8, ["buttonText"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(piniaStore).selectedFile?.name ?? ''), 1),
          _createElementVNode("div", _hoisted_4, [
            (_unref(store).getters.hasFileAdminAccess)
              ? (_openBlock(), _createBlock(TooltipStandardV2, {
                  key: 0,
                  text: _unref(t)('general__text__delete'),
                  arrowPosition: 'top-center',
                  verticalOffset: 2
                }, {
                  default: _withCtx(() => [
                    _createVNode(ButtonText, {
                      class: "header__buttons__button",
                      iconLeft: require('@/design-system/assets/icons/Icon-Trash-2-small.svg'),
                      size: "extra-small",
                      onOnClicked: _cache[3] || (_cache[3] = ($event: any) => (showConfirmDelete.value = true))
                    }, null, 8, ["iconLeft"])
                  ]),
                  _: 1
                }, 8, ["text"]))
              : _createCommentVNode("", true),
            (_unref(store).getters.hasFileEditorAccess)
              ? (_openBlock(), _createBlock(TooltipStandardV2, {
                  key: 1,
                  text: _unref(t)('general__text__archive'),
                  arrowPosition: 'top-center',
                  verticalOffset: 2
                }, {
                  default: _withCtx(() => [
                    _createVNode(ButtonText, {
                      class: "header__buttons__button",
                      iconLeft: require('@/design-system/assets/icons/Icon-Archive-Small.svg'),
                      size: "extra-small",
                      onOnClicked: _cache[4] || (_cache[4] = ($event: any) => (archiveFile()))
                    }, null, 8, ["iconLeft"])
                  ]),
                  _: 1
                }, 8, ["text"]))
              : _createCommentVNode("", true),
            _createVNode(TooltipStandardV2, {
              text: _unref(t)('general__text__download'),
              arrowPosition: 'top-center',
              verticalOffset: 2
            }, {
              default: _withCtx(() => [
                _createVNode(ButtonText, {
                  class: "header__buttons__button",
                  iconLeft: require('@/design-system/assets/icons/Icon-Download-small.svg'),
                  size: "extra-small",
                  onOnClicked: _cache[5] || (_cache[5] = ($event: any) => (downloadFile()))
                }, null, 8, ["iconLeft"])
              ]),
              _: 1
            }, 8, ["text"]),
            _createVNode(ButtonText, {
              class: "header__buttons__button",
              iconLeft: require('@/design-system/assets/icons/Icon-X-Small.svg'),
              size: "extra-small",
              onOnClicked: _cache[6] || (_cache[6] = ($event: any) => (closeModal()))
            }, null, 8, ["iconLeft"])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["content", { 'content__overflow-hidden': fileType.value === 'pdf' }])
        }, [
          (fileBlobSource.value && !loadingFile.value && fileType.value === 'pdf')
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(pdfvuer), {
                key: 0,
                class: "content__pdf",
                src: fileBlobSource.value,
                page: pdfCurrentPage.value
              }, null, 8, ["src", "page"]))
            : _createCommentVNode("", true),
          (fileBlobSource.value && !loadingFile.value && fileType.value === 'pdf')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: "content__navigation__button",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (changePage('prev')))
                }, [
                  _createVNode(IconChevronLeft)
                ]),
                _createElementVNode("span", _hoisted_6, _toDisplayString(pdfCurrentPage.value) + " / " + _toDisplayString(pdfNumPages.value), 1),
                _createElementVNode("button", {
                  class: "content__navigation__button",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (changePage('next')))
                }, [
                  _createVNode(IconChevronRight)
                ])
              ]))
            : _createCommentVNode("", true),
          (fileBlobSource.value && !loadingFile.value && fileType.value !== 'pdf')
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                class: "content__image",
                src: fileBlobSource.value,
                alt: _unref(t)('general__text__preview-not-available-for-file-type')
              }, null, 8, _hoisted_7))
            : _createCommentVNode("", true),
          (showPreviewFailedText.value && !loadingFile.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(t)('general__text__preview-failed')), 1))
            : _createCommentVNode("", true),
          (loadingFile.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(PulseLoader, {
                  color: "#3f46d6",
                  size: "16px"
                })
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _: 1
  }))
}
}

})